export enum InviteFriendsScreens {
  INVITE_FRIENDS = 'Invite Friends',
  TERMS = 'Terms',
}
